import PropertyCollapsedRoomPackageActions from './PropertyCollapsedRoomPackageActions'
import { CroSppCollapsedPackagesVariant } from './useCroSppCollapsedPackagesExperiment'

interface Props {
  duration: number
  rates: Array<App.EnrichedPropertyRate>
  packageCount: number
  packagesExpanded: boolean
  packagesVariant: CroSppCollapsedPackagesVariant
  onTogglePackages: () => void
}

function PropertyRoomPackageVariantActions(props: Props) {
  const {
    duration,
    rates,
    packageCount,
    packagesExpanded,
    packagesVariant,
    onTogglePackages,
  } = props

  if (packagesVariant === CroSppCollapsedPackagesVariant.control) {
    return null
  }

  return <PropertyCollapsedRoomPackageActions
    duration={duration}
    rates={rates}
    packageCount={packageCount}
    expanded={packagesExpanded}
    onTogglePackages={onTogglePackages}
  />
}

export default PropertyRoomPackageVariantActions
